<app-slide-over [open]="open"
                [title]="'>_ EXPORTAR ESTIMACIÓN'"
                [width]="420"
                (closed)="requestClose()">
  <div class="export-panel">

    <!-- 1. PREVIEW COMPACTO ------------------------------------------------ -->
    <section class="export-preview" *ngIf="payload">
      <div class="preview-stat">
        <span class="stat-value">{{ payload.summary.taskCount }}</span>
        <span class="stat-label">Tareas</span>
      </div>
      <div class="preview-stat">
        <span class="stat-value">{{ payload.summary.totalHours }}H</span>
        <span class="stat-label">Total</span>
      </div>
      <div class="preview-provenance">
        <span class="prov-pill prov-ai"
              *ngIf="provenanceCount(ExportProvenance.AI) + provenanceCount(ExportProvenance.AI_MODIFIED) > 0">
          IA {{ provenanceCount(ExportProvenance.AI) + provenanceCount(ExportProvenance.AI_MODIFIED) }}
        </span>
        <span class="prov-pill prov-historic"
              *ngIf="provenanceCount(ExportProvenance.HISTORIC) + provenanceCount(ExportProvenance.HISTORIC_MODIFIED) > 0">
          Hist. {{ provenanceCount(ExportProvenance.HISTORIC) + provenanceCount(ExportProvenance.HISTORIC_MODIFIED) }}
        </span>
        <span class="prov-pill prov-manual"
              *ngIf="provenanceCount(ExportProvenance.MANUAL) + provenanceCount(ExportProvenance.MANUAL_MODIFIED) > 0">
          Manual {{ provenanceCount(ExportProvenance.MANUAL) + provenanceCount(ExportProvenance.MANUAL_MODIFIED) }}
        </span>
      </div>
    </section>

    <!-- 2. SELECTOR DE DESTINO --------------------------------------------- -->
    <section class="export-section">
      <h3 class="section-subtitle">Destino</h3>

      <div class="destination-grid" *ngIf="hasAvailableDestinations; else emptyDestinations">
        <button *ngFor="let d of descriptors"
                type="button"
                class="destination-chip"
                [class.selected]="selectedId === d.id"
                [class.locked]="!d.authorized"
                [disabled]="!d.authorized"
                [attr.aria-pressed]="selectedId === d.id"
                [attr.aria-disabled]="!d.authorized"
                [title]="d.authorized ? d.shortHint : 'Sin permiso para este destino'"
                (click)="selectDestination(d.id)">
          <svg class="dest-icon" viewBox="0 0 24 24" aria-hidden="true">
            <path [attr.d]="d.iconSvgPath"></path>
          </svg>
          <span class="dest-label">{{ d.label }}</span>
          <span class="dest-hint">{{ d.shortHint }}</span>
          <span class="dest-lock" *ngIf="!d.authorized" aria-hidden="true">
            <svg viewBox="0 0 24 24" width="12" height="12">
              <path fill="currentColor"
                    d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6z"/>
            </svg>
          </span>
        </button>
      </div>

      <ng-template #emptyDestinations>
        <div class="empty-destinations">
          <p>No hay destinos disponibles todavía.</p>
          <p class="empty-sub">Se irán activando a medida que se registren exporters.</p>
        </div>
      </ng-template>
    </section>

    <!-- 3. OPCIONES (chip OAuth + options form dinámico + toggle extras) -->
    <section class="export-section" *ngIf="selectedId">
      <h3 class="section-subtitle">Opciones</h3>
      <div class="export-options-host">

        <!-- 3a. Chip de conexión OAuth si el destino lo requiere -->
        <app-integration-connection-chip
            *ngIf="selectedDescriptor?.requiresIntegration as p"
            [provider]="p"
            (connectionChanged)="onIntegrationConnectionChanged()">
        </app-integration-connection-chip>

        <!-- 3b. Options form del exporter, montado dinámicamente -->
        <div class="dynamic-options-host">
          <ng-container #optionsHost></ng-container>
        </div>

        <!-- 3c. Toggle "Incluir campos completos del servidor" -->
        <label class="option-toggle" *ngIf="supportsExtrasToggle">
          <input type="checkbox" [(ngModel)]="includeExtras" />
          <span class="toggle-track"><span class="toggle-thumb"></span></span>
          <span class="toggle-label">
            <span class="toggle-title">Incluir campos completos del servidor</span>
            <span class="toggle-hint">Enriquece el payload con datos extra de BBDD antes de exportar</span>
          </span>
        </label>

        <p class="options-empty" *ngIf="!hasOptionsForSelected">
          Este destino no requiere opciones adicionales.
        </p>
      </div>
    </section>

    <!-- 4. CTA ------------------------------------------------------------- -->
    <footer class="export-footer">
      <button type="button"
              class="btn primary btn-glow"
              [disabled]="!canExport"
              (click)="runExport()">
        <svg *ngIf="running" class="spinner-icon" viewBox="0 0 24 24" aria-hidden="true">
          <path fill="currentColor"
                d="M12 2v4c4.41 0 8 3.59 8 8s-3.59 8-8 8-8-3.59-8-8H2c0 5.52 4.48 10 10 10s10-4.48 10-10S17.52 2 12 2z"/>
        </svg>
        <svg *ngIf="!running" viewBox="0 0 24 24" aria-hidden="true">
          <path fill="currentColor"
                d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"/>
        </svg>
        {{ running ? 'EXPORTANDO...' : 'EXPORTAR' }}
      </button>
    </footer>

  </div>
</app-slide-over>
